import { TranslationKeyTranslation } from '../../../models/translation';
import { WeekDayEnum } from '../../../models/weekday.enum';

export const translationsDe: TranslationKeyTranslation = {
  yes: 'Ja',
  no: 'Nein',
  all: 'Alle',
  job: 'Dienst',
  jobSeries: 'Dienstserie',
  jobRequest: 'Dienstanfrage',
  german: 'Deutsch',
  english: 'Englisch',
  french: 'Französisch',
  created: 'Erstellt',
  updated: 'Geändert',
  status: 'Status',
  loadAll: 'Alle Laden',
  loadMore: 'Mehr laden',
  download: 'Download',
  cancelItem: 'Stornieren',
  externalCancellations: 'Externe Stornierungen',
  duplicate: 'Duplizieren',
  summary: 'Zusammenfassung',
  clearSelection: 'Auswahl löschen',
  fieldRequiredError: 'Bitte füllen Sie dieses Pflichtfeld aus',
  overlappingTrackings: 'Bitte überlappend Schichten korrigieren',
  badTimeSpan: 'Von und Bis Zeiten drüfen nicht gleich sein',
  pauseTooBig: 'Pause darf nicht grösser sein als die Arbeitszeit',
  submit: 'einreichen',
  name: 'Name',
  firstName: 'Vorname',
  lastName: 'Nachname',
  email: 'E-Mail',
  sms: 'SMS',
  phone: 'Telefon',
  password: 'Passwort',
  setPassword: 'Passwort setzen',
  resetPassword: 'Passwort zurücksetzen',
  forgotPassword: 'Passwort vergessen?',
  newPassword: 'Neues Passwort',
  repeatPassword: 'Passwort wiederholen',
  passwordDoesntMatch: 'Passwort stimmt nicht überein',
  passwordIsToShort: 'Passwort ist zu kurz.',
  required: 'Erforderlich',
  inputDoesNotMatch: 'Eingabe stimmt nicht überein',
  login: 'anmelden',
  loading: 'Lädt...',
  loggingIn: 'Anmeldung läuft...',
  reset: 'zurücksetzen',
  goToLogin: 'zum Login',
  add: 'hinzufügen',
  cancel: 'Abbrechen',
  back: 'zurück',
  search: 'suchen...',
  sex: 'Geschlecht',
  maleSex: 'Mann',
  femaleSex: 'Frau',
  otherSex: 'Andere',
  salutation: 'Anrede',
  mr: 'Herr',
  mrs: 'Frau',
  date: 'Datum',
  weekday: 'Wochentag',
  timeOfDay: 'Uhrzeit',
  cancelTime: 'Absagezeitpunkt',
  dateFrom: 'Datum von',
  dateTo: 'Datum bis',
  startDate: 'Startdatum',
  endDate: 'Enddatum',
  startTime: 'Startzeit',
  endTime: 'Endzeit',
  bookedAt: 'Gebucht am',
  total: 'Total',
  employees: 'Mitarbeitende',
  employee: 'Mitarbeitender',
  save: 'speichern',
  edit: 'bearbeiten',
  remove: 'entfernen',
  details: 'Details',
  welcome: 'willkommen',
  state: 'Status',
  confirm: 'bestätigen',
  description: 'Beschreibung',
  close: 'schliessen',
  hide: 'ausblenden',
  filter: 'Filter',
  decline: 'ablehnen',
  moreOptions: 'weitere optionen',
  transfer: 'transferieren',
  transcribe: 'Übertragen',
  done: 'Erledigt',
  toComplete: 'Erledigen',
  areYouSure: 'Bist du sicher?',
  areYouSurePolite: 'Sind Sie sicher?',
  unsavedChangesTitle: 'Ungespeicherte Änderungen',
  unsavedChangesText:
    'Sie haben ungespeicherte Änderungen. Möchten Sie wirklich fortfahren?',
  pleaseEnterName: 'Bitte geben Sie ihren vollständigen Namen ein.',
  orderId: 'Bestellnummer',
  branch: 'Filiale',
  create: 'erstellen',
  new: 'neu',
  from: 'von',
  to: 'bis',
  pause: 'pause',
  selectDateRange: 'Datumsbereich auswählen',
  noUsersFound: 'Keine Mitarbeitende gefunden',
  showAll: 'Alle anzeigen',
  showLess: 'Weniger anzeigen',
  or: 'oder',
  editor: 'Bearbeiter:in',
  creator: 'Ersteller:in',
  availabilities: 'Verfügbarkeiten',
  jobAvailabilities: 'Springer-Verfügbarkeiten',
  employmentAvailabilities: 'Temporär-Verfügbarkeiten',
  organisationAndDepartment: 'Organisation, Abteilung',
  timespan: 'Zeitraum',
  now: 'Jetzt',
  request: 'Anfragen',
  availabilitiesNoUmlaut: 'Verfuegbarkeiten',
  availabilitiesTemporary: 'Verfügbarkeiten Temporäre',
  availability: 'Verfügbarkeit',
  label: 'Bezeichnung',
  notificationType: 'Benachrichtigungstyp',
  weekdays: {
    [WeekDayEnum.MONDAY]: 'Montag',
    [WeekDayEnum.TUESDAY]: 'Dienstag',
    [WeekDayEnum.WEDNESDAY]: 'Mittwoch',
    [WeekDayEnum.THURSDAY]: 'Donnerstag',
    [WeekDayEnum.FRIDAY]: 'Freitag',
    [WeekDayEnum.SATURDAY]: 'Samstag',
    [WeekDayEnum.SUNDAY]: 'Sonntag',
  },
  carLicenseEnum: {
    '0': 'Fahrausweis verfügbar',
    '1': 'Auto und Fahrausweis verfügbar',
  },
  languageEnum: {
    '0': 'Deutsch',
    '1': 'Englisch',
    '2': 'Italienisch',
    '3': 'Französisch',
  },
  poolerType: 'Poolertyp',
  mobility: 'Mobilität',
  languages: 'Sprachen',
  language: 'Sprache',
  systemLanguage: 'Systemsprache',
  departments: 'Abteilungen',
  department: 'Abteilung',
  clinic: 'Klinik',
  section: 'Departement',
  all_departments: 'Alle Abteilungen',
  available: 'verfügbar',
  unavailable: 'abwesend',
  booked: 'Gebucht',
  shift: 'Schicht',
  shiftPlural: 'Schichten',
  shiftNotAvailableOnDepartment: 'Schicht nicht verfügbar bei dieser Abteilung',
  customer: 'Kunde',
  agency: 'Vermittler',
  offerFrom: 'Angebot von',
  all_agencies: 'Alle Vermittler',
  verify: 'verifizieren',
  twoFa: 'Zwei-Faktor-Authentifizierung',
  resendAuthCode: 'Code erneut senden',
  authCodeSentTo: 'Wir haben dir einen Bestätigungscode an',
  authCodeSentToYourPhone: 'geschickt. Bitte gib den Code hier ein.',
  codeInvalidOrExpired: 'Code ist ungültig oder abgelaufen',
  requiredField: 'Pflichtfeld',
  emailInvalid: 'Keine gültige Email',
  phoneConfirmation: 'Telefon Bestätigung',
  noPoolerFound: 'Keine Pooler gefunden',
  phoneNumber: 'Telefonnummer',
  emailAddress: 'E-Mail-Adresse',
  additionalInfo: 'Zusatzinformationen',
  additionalAvailabilityInfo: 'Zusatzinformationen zur Verfügbarkeit',
  additionalAvailabilityInfoPlaceholder: 'z.B. nur bis 22:00 Uhr verfügbar',
  statusEnum: {
    '0': 'Offen',
    '1': 'Archiviert',
    '2': 'geschlossen',
    '3': 'abgelehnt',
    '4': 'Verfügbar',
    '5': 'Nicht verfügbar',
    '6': 'Gebucht',
    '7': 'angefordert',
    '8': 'Nicht vorhanden',
    '9': 'Abgesagt',
    '10': 'In Arbeit',
    '11': 'Pool entfernt',
    '12': 'Vorhanden',
    '13': 'Möglicher Kandidat',
  },
  jobStatusEnum: {
    OPEN: 'Offen',
    ARCHIVED: 'Archiviert',
    CLOSED: 'geschlossen',
    CANCELED: 'Abgesagt',
    JOB_REQUESTED: 'Dienst angefragt',
  },
  inviteeStatusEnum: {
    OPEN: 'Offen',
    DECLINED: 'abgelehnt',
    AVAILABLE: 'Verfügbar',
    UNAVAILABLE: 'Nicht verfügbar',
    BOOKED: 'Gebucht',
    CANCELED: 'Abgesagt',
    WORKING: 'In Arbeit',
    POSSIBLE_CANDIDATE: 'Möglicher Kandidat',
    TRANSFERRED: 'Transferiert',
    PARTIAL_AVAILABLE: 'Teilweise verfügbar',
  },
  customerUserStatusEnum: {
    REQUESTED: 'angefordert',
    INEXISTENT: 'Nicht vorhanden',
    POOL_REMOVED: 'Pool entfernt',
    EXISTENT: 'Vorhanden',
  },
  submitted: 'Eingereicht',
  bookedBy: 'Gebucht von',
  bookedIn: 'Gebucht bei ',
  availabilityOverviewBookedCounts: 'In dieser Station gebucht / Total gebucht',
  perPooler: 'pro pooler',
  perDepartment: 'pro abteilung',
  perOrganisation: 'pro organisation',
  organisations: 'Organisationen',
  organisation: 'Organisation',
  addTag: 'Tag hinzufügen',
  originalCertificates: 'Ursprüngliche Qualifikationen',
  originalSpecialities: 'Ursprüngliche Erfahrungen',
  originalSex: 'Ursprüngliche Geschlecht',
  originalCar: 'Ursprüngliche Mobilität',
  originalLanguage: 'Ursprüngliche Sprache',
  originally: 'Ursprünglich',
  empty: 'leer',
  createLink: 'Link erstellen',
  hours: 'Stunden',
  toAdd: 'stunden erfassen',
  toApprove: 'zu genehmigen',
  approved: 'freigegeben',
  inviteeTransferReason: 'Grund für die Umbuchung',
  transferInviteTarget: 'Umbuchungs-Ziel',
  transferCreateNewJob: 'Neuer Dienst',
  disabledBecauseExternalTransfer:
    'Die Kriterien-Anpassung ist deaktiviert, weil der Dienst an externe Vermittler transferiert wurde. Qualifikationen können nur hinzugefügt, aber nicht entfernt werden.',
  createNewTag: 'Neuen Tag erstellen',
  reports: 'Berichte',
  informInviteeOfReason: 'Mitarbeitenden über den Grund informieren',
  selectAllDepartments: 'Alle sichtbaren Abteilungen auswählen',
  deselectAllDepartments: 'Alle sichtbaren Abteilungen abwählen',
  allDepartments: 'Alle Abteilungen',
  areYouSureSelectAllDepartments:
    'Sind Sie sicher, dass Sie alle sichtbaren Abteilungen auswählen möchten?',
  areYouSureDeselectAllDepartments:
    'Sind Sie sicher, dass Sie alle sichtbaren Abteilungen abwählen möchten?',
  approvedAt: 'Freigegeben am',
  approvedBy: 'Freigegeben von',
  timeTracking: 'Zeiterfassung',
  disableTimeTracking: 'Zeiterfassung deaktivieren',
  disableTimeTrackingDescription:
    'Wenn Sie die Zeiterfassung deaktivieren, können Sie keine Stunden erfassen und die noch ausstehenden Stundenerfassungen werden gelöscht.',
  enableTimeTracking: 'Zeiterfassung aktivieren',
  enableTimeTrackingDescription:
    'Wenn Sie die Zeiterfassung aktivieren, wird dies für alle zukünftig erstellten Dienste gelten, jedoch nicht für bereits erfasste Dienste.',
  jobType: 'Dienstart',
  jobTypeEnum: {
    '1': 'Normal',
    '2': 'Sitzwache',
    '3': '1 zu 1',
  },
  demandReasonEnum: {
    WORKLOAD: 'Arbeitslast / Aufwändige Pflege',
    LACK_OF_STAFF: 'Personalmangel / Unbesetzte Stelle',
    ACCIDENT: 'Unfall',
    SICKNESS: 'Krankheit',
    ONE_ON_ONE: '1:1 Betreuung',
    PATIENT_SITTING: 'Sitzwache',
    OTHER: 'Anderer Grund',
  },
  cancelCostWarningTitle: 'Mögliche Stornokosten',
  cancelCostWarningMessage:
    'Sie stornieren eine Person innerhalb der kostenpflichtigen Stornofrist. Bei Fragen wenden Sie sich bitte an Ihren Vermittler. \n Möchten Sie trotzdem fortfahren?',
  maleGreeting: 'Lieber',
  femaleGreeting: 'Liebe',
  neutralGreeting: 'Hallo',
  sincerely: 'Herzliche Grüsse',
  noReplyMessage:
    'Dies ist eine automatisch generierte E-Mail. Bitte nicht darauf antworten.',
  buttonNotWorking: 'Funktioniert die Schaltfläche nicht?',
  requestType: 'Request Art',
  endpoint: 'Endpunkt',
  requestBody: 'Request Body',
  errorMessage: 'Fehlermeldung',
  key: 'Feld',
  newValue: 'Neuer Wert',
  oldValue: 'Alter Wert',
  jobPool: 'Springer-Pool',
  employmentPool: 'Temporär-Pool',
  calendarWeekShort: 'KW',
  employmentDuration: 'Einsatzdauer',
  newEmployment: 'Neuer Einsatz',
  declined: 'Abgelehnt',
  address: 'Adresse',
  departmentPhone: 'Stationsnummer',
  workload: 'Pensum',
  workloadInPercent: 'Pensum in %',
  newVersionTitle: 'Neue Version verfügbar',
  newVersionText:
    'Bitte laden Sie die Seite neu, um die neueste Version zu verwenden.',
  reload: 'Neu laden',
  declineReasonEnum: {
    CERTIFICATE_NOT_FIT: 'Qualifikation passt nicht',
    BAD_PRIOR_EXPERIENCE: 'Ungenügende Leistung beim letzten Einsatz',
    OTHER_INVITEE_BOOKED: 'Ein anderer Mitarbeitender wurde gebucht',
    JOB_CANCELLED: 'Dienst wurde storniert',
    OTHER: 'Anderer Grund',
  },
  certificates: 'Qualifikationen',
  specialities: 'Erfahrungen / Pflegebereiche',
  transferredBy: 'Transferiert von',
  createdBy: 'Erstellt von',
  list: 'Liste',
  calendar: 'Kalender',
  shifts: {
    '0': 'Früh',
    '1': 'Mittel',
    '2': 'Spät',
    '3': 'Nacht',
  },
  shiftLetters: {
    '0': 'F',
    '1': 'M',
    '2': 'S',
    '3': 'N',
  },
  jobRequests: 'Dienstanfragen',
  userRole: 'Rolle',
  roleEnum: {
    0: 'Pooler',
    1: 'Disponent',
    2: 'Besteller',
  },
  agencies: 'Vermittler',
  continue: 'Weiter',
  jobTypes: 'Dienstarten',
  tiles: 'Kacheln',
  inEmployment: 'Im Einsatz',
  saved: 'Gespeichert',
  profileSaved: 'Profil gespeichert',
  jobSaved: 'Dienst gespeichert',
  serverError: 'Serverfehler',
  wrongOrExpiredToken: 'Token falsch oder abgelaufen',
  documentUploaded: 'Dokument erfolgreich hochgeladen',
  saveJobBeforeTransfer:
    'Bitte Speichere deine Änderungen vor dem Transferieren',
  documentRemoved: 'Dokument erfolgreich entfernt',
  xNewJobsCreated: '{{count}} neue Dienste erstellt',
  noUserConnectedWithMicrosoft: 'Kein Benutzer mit Microsoft Login verknüpft',
  loginExpired: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
  multidayUsersInvitedAndBooked:
    '{{inviteCount}} eingeladen und {{bookCount}} gebucht',
  multidayUsersInvited: '{{count}} eingeladen',
  multidayUsersBooked: '{{count}} gebucht',
  registerSuccess:
    'Vielen Dank für deine Eingabe, wir melden uns zeitnah bei dir',
  notAllowed: 'Das dürfen Sie nicht',
  notSupported: 'Ihr Browser unterstützt diese Funktion nicht',
  sentInvitation: 'Einladung gesendet',
  maxFileUploadExceeded: 'Max. Dateigröße überschritten',
  noCustomerAssigned: 'Diesem Benutzer wurde kein Kunde zugeordnet',
  phoneNumberOccupied: 'Diese Nummer ist schon vergeben',
  newJobCreated: 'Dienst erstellt',
  jobClosed: 'Dienst abgeschlossen',
  reAskedInvitee: 'Mitarbeitender nochmals angefragt',
  jobTransferred: 'Dienst transferiert',
  jobCanceled: 'Dienst storniert',
  inviteeCanceled: 'Gebuchter Mitarbeitender wurde storniert',
  passwordResetEmailSent: 'E-Mail zum Passwort ändern wurde versendet',
  xJobsDeclined: '{{count}} Dienste wurden abgesagt',
  jobOverlapsDetectedForNames: 'Schichten überschneiden sich bei {{names}}',
  userNotFound: 'Benutzer wurde nicht gefunden',
  couldntCreateTag: 'Tag konnte nicht erstellt werden',
  tagAlreadyExists: 'Tag existiert bereits',
  tagStillInUse: 'Tag wird noch verwendet',
  tagAlreadyOnOrganisation: 'Tag ist bereits auf Organisation',
  couldntDeleteTag: 'Tag konnte nicht gelöscht werden',
  successfullyDeletedTag: 'Tag erfolgreich gelöscht',
  tagAdded: 'Tag hinzugefügt',
  tagRemoved: 'Tag entfernt',
  userRemovedFromPool: 'Benutzer wurde aus dem Pool entfernt',
  usernameOrPasswordWrong: 'E-Mail-Adresse oder Passwort falsch',
  cannotViewMoreThan90Days:
    'Die Datumsspanne darf nicht größer als 90 Tage sein.',
  demoResetNotice:
    'Herzlich willkommen zur Demo von inpool. Bitte beachten Sie, dass die Benachrichtigungen per E-Mail und SMS in der Demo standardmässig deaktiviert sind. Alle Daten werden über Nacht zurückgesetzt',
  optInEmailMessage:
    'Bitte bestätigen Sie die neue E-Mail Adresse mit dem Bestätigungslink, welchen wir Ihnen per E-Mail gesendet haben',
  optInPhoneMessage:
    'Bitte bestätigen Sie die neue Telefonnummer mit dem Bestätigungslink, welchen wir Ihnen per SMS gesendet haben',
  sentNewSMSToken: 'SMS-Bestätigungscode versendet.',
  confirmEmailLink:
    'Bitte bestätige deine E-Mail-Adresse indem du auf den Link klickst welchen wir dir per E-Mail zugestellt haben.',
  optInEmailExists: 'Ein Account mit dieser E-Mail-Adresse existiert bereits.',
  optInPhoneExists: 'Ein Account mit dieser Telefonnummer existiert bereits.',
  optInSuccessMessage: 'Die Änderung wurde erfolgreich bestätigt',
  optInErrorMessage:
    'Änderung konnte nicht durchgeführt werden. Entweder war der verwendete Link abgelaufen, unvollständig oder für diesen Benutzer ungültig. Bitte führen Sie die Änderung nochmals durch',
  alreadyInPool:
    'Ein Benutzer mit dieser E-Mail-Adresse befindet sich bereits im Pool',
  alreadyRequested: 'Der Benutzer ist bereits eingeladen',
  alreadyAdded: 'Dieser Benutzer wurde bereits hinzugefügt',
  changeEmailNotAllowedForNewUser:
    'E-Mail-Adresse darf nicht geändert werden beim Erstellen eines neuen Benutzers',
  userCreated: 'Der Benutzer wurde erfolgreich erstellt',
  savedDefaultFilter: 'Der Filter wurde erfolgreich als Standard gespeichert',
  userInvitedAgain: 'Der Benutzer wurde erneut eingeladen',
  userUnlocked: 'Der Benutzer wurde freigeschaltet',
  connectionLost: 'Verbindung verloren. Automatischer Verbindungsversuch...',
  connectionOffline:
    'Verbindung getrennt. Bitte stelle sicher, dass eine Internetverbindung besteht und lade dann die Seite neu.',
  hoursTransferred: 'Stunden übermittelt',
  successfullyAddedInvitee: 'Mitarbeitender erfolgreich hinzugefügt',
  JobNotFound: 'Dienst wurde nicht gefunden',
  userAlreadyExistsAsDispo:
    'Der Benutzer ist bereits als Disponent registriert',
  userAlreadyExistsAsPooler:
    'Der Benutzer ist bereits als Mitarbeitender registriert',
  JobNotOpen: 'Dienst ist nicht mehr offen',
  SecretInvalid: 'Keine Berechtigung',
  InvalidForm: 'Felder sind nicht korrekt ausgefüllt',
  JobAutomaticallyClosed: 'Dienst wurde erfolgreich abgeschlossen',
  transferDeclined: 'Dienst wurde erfolgreich abgelehnt',
  removedSuccessfully: 'Erfolgreich gelöscht',
  downloadedSuccessfully: 'Erfolgreich heruntergeladen',
  fileNotFound: 'Diese Datei konnte nicht gefunden werden',
  jobInsertError: 'Fehler beim erstellen des Dienstes',
  multiJobInsertError:
    'Einer oder mehrere Dienste konnten nicht erstellt werden',
  cantBookInvitee: 'Der Mitarbeitende konnte nicht gebucht werden',
  cantBookReasonUserBlacklistedDepartment:
    'Der Mitarbeitende hat diese Abteilung auf der Blacklist',
  cantBookReasonDepartmentNotAssigned:
    'Der Mitarbeitende hat die Abteilung des Dienstes nicht zugewiesen',
  cantBookReasonNotAvailable:
    'Der Mitarbeitende ist für diesen Dienst nicht verfügbar',
  cantBookReasonDepartmentBlacklistedUser:
    'Die Abteilung hat diesen Mitarbeitenden auf der Blacklist',
  cantBookReasonCanBeBooked:
    'Der Mitarbeitende kann für diesen Dienst gebucht werden',
  loginForbidden: 'Anmeldung abgelehnt',
  authCodeResent: 'Bestätigungscode erneut gesendet',
  phoneNotFound: 'Es wurde keiner gültigen Telefonnummer gefunden.',
  phoneNotVerified: 'Telefonnummer ist nicht verifiziert.',
  contactSupport: 'Bitte kontaktieren Sie den Support.',
  InviteesAlreadyExists: 'Pooler bereits vorhanden',
  inviteeTransferred: 'Erfolgreich umgebucht',
  inviteeDoesNotFitCriteria:
    'Eingeladener Mitarbeitender passt nicht zu den Kriterien',
  inviteeNoLongerFitCriteria:
    'Eingeladener Mitarbeitender passt nicht mehr zu den Kriterien',
  requiredUsersBelowBookedCount:
    'Benötigte Mitarbeiter dürfen nicht weniger sein als bereits gebuchte',
  inviteeInvitedTwice: 'Mitarbeitender wurde bereits eingeladen',
  duplicateInvitationError:
    'Es gibt ein Problem mit dem Dienst (Doppelte Einladung). Bitte lade die Seite neu und versuche es erneut.',
  duplicateInvitationErrorUnclearableStatus:
    'Es gibt ein Problem mit dem Dienst (Doppelte Einladung). Bitte melden Sie sich umgehend bei dem Support.',
  linkCopied: 'Link kopiert',
  inviteeHasNotHadMinimumRest:
    'Eingeladener Mitarbeitender hat nicht die Mindestruhezeit eingehalten',
  externalNoLongerDraft:
    'Der Dienst ist im externen transfer nicht mehr im Entwurf',
  userBookedSuccessfullyEmployment:
    'Der Mitarbeitende wurde für den Einsatz gebucht',
  userSuccessfullySubmittedAsEmploymentPossibleCandidate:
    'Der Mitarbeitende wurde erfolgreich als möglicher Kandidat eingereicht',
  userCanceledSuccessfullyEmployment:
    'Der Mitarbeitende wurde für den Einsatz storniert',
  userBookedSuccessfullyJob:
    'Mitarbeitender wurde erfolgreich für den Dienst gebucht',
  employmentCanceled: 'Der Einsatz wurde storniert',
  employeesInvitedSuccessfully: 'Mitarbeiter erfolgreich eingeladen',
  employmentCreated: 'Einsatz erfolgreich erstellt',
  requiredFieldsMissing: 'Bitte füllen Sie alle Pflichtfelder aus',
  changesSaved: 'Änderungen gespeichert',
  jobRequestInsertError: 'Fehler beim Erstellen der Anfrage',
  newJobRequestCreated: 'Anfrage erstellt',
  xNewJobRequestsCreated: '{{count}} Anfragen erstellt',
  jobRequestRetractError: 'Fehler beim Zurückziehen der Anfrage',
  jobRequestRetracted: 'Anfrage zurückgezogen',
  jobRequestApproved: 'Anfrage freigegeben',
  jobRequestRejected: 'Anfrage abgelehnt',
  jobs: 'Dienste',
  jobsFromDate: 'Dienste am {{datum}}',
  assignments: 'Einsätze',
  logout: 'abmelden',
  admin: 'Admin',
  profile: 'Profil',
  tariffs: 'Tarife',
  jobDefaults: 'Standard Werte',
  customerFlags: 'Admin Einstellungen',
  poolerTypes: 'Poolertypen',
  dashboard: 'Übersicht',
  activationPending: 'Freischaltung ausstehend',
  cancelReasons: 'Storno Gründe',
  agencyPriorities: 'Vermittler Prioritäten',
  sharedPoolCustomers: 'Kunden mit Zugriff auf Shared Pool',
  sharedPoolCanDirectBook: 'kann direkt buchen',
  noSharedPoolCustomers:
    'Keine Kunden mit Zugriff auf diesen Shared Pool gefunden.',
  jobRequestApproval: 'Dienstfreigaben',
  transferList: 'Übertragungsliste',
  showByTranscribedAtDate: 'Nach Übertragungsdatum anzeigen',
  only1kTranscribeJobsShown:
    'Es werden nur die neusten 1.000 Dienste angezeigt. Schränke bei Bedarf die Suche ein.',
  only1kTranscribeJobsByDateShown:
    'Es werden nur die zuletzt übertragenen 1.000 Dienste angezeigt. Schränke bei Bedarf die Suche ein.',
  transcribedAt: 'Übertragen am',
  transcribedBy: 'Übertragen von',
  bookedInvitee: 'Gebuchter Mitarbeiter',
  manualTranscribeJobListDescription:
    'Übersicht der manuellen Dienst-Übertragungen',
  noJobsToTranscribe:
    'Es gibt keine Dienste, welche übertragen werden müssen 🎉',
  noJobsTranscribedYet: 'Es wurden noch keine Dienste übertragen',
  demandReasons: 'Bestellgrund',
  requestOverview: 'Dienstmatrix',
  certificateGroups: 'Qualifikationsgruppen',
  customCriteria: 'Weitere Kriterien',
  addCustomCriteriaGroup: 'Weiteres Kriterium hinzufügen',
  customCriteriaTypeToggle: 'Schalter',
  customCriteriaTypeSelect: 'Auswahl',
  defaultValue: 'Standard',
  defaultValueForPooler: 'Standardwert auf Profil',
  defaultValueForJob: 'Standardwert auf Dienst',
  customCriteriaBlockingToggle:
    'Blockiert den Mitarbeiter, wenn Mitarbeiter Kriterium an hat, der Dienst jedoch nicht.',
  multipleSelection: 'Mehrfachauswahl',
  addOption: 'Option hinzufügen',
  customCriteriaUserEditable: 'Im eigenen Profil durch Springer bearbeitbar',
  customCriteriaEnableOnJobRequest: 'Bei Dienstanfragen anzeigen',
  jobsPool: 'Springer-Pool',
  employmentsPool: 'Temporär-Pool',
  addTariff: 'Tarif hinzufügen',
  hourlyWage: 'Stundentarif CHF',
  addDefault: 'Standard hinzufügen',
  enablePoolerTypes: 'Poolertypen aktivieren',
  enableDemandReasons: 'Bestellgründe aktivieren',
  prioritizeEmployeeLastName: 'Nachname vor Vorname anzeigen',
  transferredJobsNoLongerActionRequired:
    'Offene transferierte Dienste als grauer Dienst anzeigen',
  approvedJobRequestsNoLongerActionRequired:
    'Genehmigte Dienstanfragen als graue Dienstanfrage anzeigen',
  enableCopyDateOnDuplicate: 'Beim Duplizieren das Datum übernehmen',
  enableAutoDirectAccept: 'Automatische direktbuchung aktivieren',
  preventAutoDirectAcceptWithinHours:
    'Automatische direktbuchung innerhalb von x Stunden vor Dienstbeginn deaktivieren',
  allowIgnoreUserPreferenceDepartmentBlacklist:
    'Ignorieren der Abteilungspräferenz der Mitarbeiter erlauben',
  preventChangingOfCreator:
    'Verhindern, dass der Ersteller eines Dienstes geändert wird',
  timeTrackingEnabled: 'Zeiterfassung aktivieren',
  timeTrackingDescriptionRequiredOnChange:
    'Beschreibung erforderlich bei Änderung der Zeiterfassung',
  timeTrackingAutoApproveInDays:
    'Zeiterfassung automatisch freigeben nach X Tagen wenn nicht von Disponenten freigegeben',
  timeTrackingDefaultPauseInHours: 'Standardpause in Stunden',
  enableJobRequestApproval: 'Freigabe von Dienstanfragen erforderlich',
  enableCaseNumberInJobRequests: 'Fallnummer in Dienstanfragen aktivieren',
  addNotification: 'Benachrichtigung hinzufügen',
  noNotificationsConfigured: 'Keine Benachrichtigungen konfiguriert',
  addTimeRange: 'Zeitbereich hinzufügen',
  timeFrom: 'Von',
  timeTo: 'Bis',
  wholeDay: 'Ganzer Tag',
  enableRequestOverview: 'Dienstmatrix anzeigen',
  enableSectionToggleInJobMatrix:
    'Departement-Toggle in Dienstmatrix aktivieren',
  disableTimetrackingForOwnPoolers:
    'Zeiterfassung für eigene Pooler deaktivieren',
  enableTimetrackingForNewOrganisationsByDefault:
    'Zeiterfassung für neue Organisationen standardmässig aktivieren',
  disableApproveTimetrackingNotificationsForTransfers:
    'Zeiterfassung-Freigabe-Benachrichtigungen für Transfers deaktivieren',
  requestOverviewHideCanceledJobs: 'Dienstmatrix stornierte Dienste ausblenden',
  requestOverviewForRequester: 'Dienstmatrix für Besteller anzeigen',
  enableMonthlyHours: 'Monatliches Pensum in Stunden anzeigen',
  enableTranscribeJobList: 'Dienst-Übertragungsliste aktivieren',
  enableTranscribeJobListDescription:
    'Liste zur Übertragung von Buchungen und Stornierungen in eine andere Software',
  exceptions: 'Ausnahmen',
  requestOverviewCertificatePriority:
    'Qualifikationsprioritäten für die Dienstmatrix',
  requestOverviewCertificatePriorityDescription:
    'Die Prioritäten werden in der Dienstmatrix von oben nach unten berücksichtigt. Dienste mit mehreren Qualifikationen werden nur für die höchste Priorität angezeigt.',
  addCertificatePriority: 'Qualifikationspriorität hinzufügen',
  addPoolerType: 'Poolertyp hinzufügen',
  confirmPoolerTypeDeletion:
    'Möchten Sie diese Poolertyp wirklich löschen? \n Es gibt {{count}} Pooler mit dieser Art.',
  addDemandReason: 'Grund hinzufügen',
  enableDescriptions: 'Beschreibungstext',
  addCancelReason: 'Stornogrund hinzufügen',
  addCertificateGroup: 'Qualifikationsgruppe hinzufügen',
  addConditionalTransfer: 'Transfer-bedingungen hinzufügen',
  hoursBeforeJobStart: 'Regel aktiv ab x und Stunden weniger vor Dienstbeginn',
  blockingHours: 'Vorlauf (h)',
  conditionalTransfersDescription:
    'Hier können Sie die Bedingungen für den Transfer an Vermittler festlegen. Die Bedingungen werden nur angewendet, wenn der Dienstbeginn innerhalb der angegebenen Zeit ist. Es wird immer die erste passende Bedingung angewendet. Wenn keine Zeit angegeben ist, wird die Bedingung immer angewendet.',
  addCustomerGroup: 'Kundengruppe hinzufügen',
  addConditionGroup: 'Bedingungsgruppe hinzufügen',
  jobsTransfers: 'Springer-Pool Transfer',
  employmentsTransfers: 'Temporär-Pool Transfer',
  sharedPool: 'Shared Pool',
  agencyPrioritiesDescription:
    'Hier können Sie die Prioritäten für den Transfer an Vermittler festlegen.',
  supplier: 'Vermittler',
  loadingReport: 'Lade Rapport',
  timeSpan: 'Zeitraum',
  noTimeSpanSelected: 'Kein Zeitraum ausgewählt',
  open: 'Offen',
  jobId: 'Job ID',
  correctionReason: 'Grund für Korrektur',
  dispoCorrectionReason: 'Grund für Korrektur (Dispo)',
  poolerCorrectionReason: 'Grund für Korrektur (Pooler)',
  departmentId: 'Abteilungs ID',
  perAgency: 'Pro Vermittler',
  timeTrackingReport: 'Stundenrapport',
  timeTrackingReportDescription:
    'Export der erfassten Arbeitszeit pro geleistetem Dienst',
  shiftsPlanningReport: 'Dienstplanung',
  jobsForInvoice: 'Dienste für Rechnung',
  jobsForInvoiceDescription: 'Liste aller Dienste für die Rechnung',
  shiftsPlanningReportDescription:
    'Enthält alle Buchungen und Stornos von bereits gebuchten Diensten für den entsprechenden Zeitraum',
  jobOverviewReport: 'Dienstübersicht',
  jobOverviewReportDescription:
    'Enthält alle Dienste mit allen Status für den gewählten Zeitraum',
  activityReport: 'Inaktivität',
  activityReportDescription:
    'Liste aller Pooler, welche für den gewählten Zeitraum inaktiv waren',
  externalCancellationTime: 'Absagezeitpunkt externe Mitarbeitende',
  externalCancellationsDescription:
    'Übersicht aller extern abgesagten Dienste.',
  canceledAt: 'Storniert am',
  canceledBy: 'Storniert von',
  cancelReason: 'Stornierungsgrund',
  cancelReasonDescription: 'Stornierungsgrund Beschreibung',
  noAvailabilities: 'Keine Verfügbarkeiten',
  noBookings: 'Keine Buchungen',
  poolerOverview: 'Pooler Übersicht',
  poolerAssignmentReportDescription:
    'Zuordnung der Pooler pro Klinik/Abteilung oder Pooler inkl. Ausbildung und Zusatzausbildung',
  userAvailabilityReport: 'Benutzer Verfügbarkeit',
  userAvailabilityReportDescription: 'Verfügbarkeit der Benutzer',
  bookedVsAvailablePercentage: 'Gebucht / Verfügbar in %',
  availableUserJobPlanningReport: 'Mitarbeiter Planung',
  availableUserJobPlanningDescription:
    'Übersicht aller Zusagen für alle offenen Dienste.',
  poolerReactionTime: 'Pooler Reaktionszeit',
  smsUsage: 'SMS Nutzung',
  smsUsageDescription:
    'Übersicht aller versendeten Textnachrichten (Kann nicht auf abteilungen begrenzt werden)',
  poolerReactionTimeDescription:
    'Übersicht aller Pooler und deren Reaktionszeiten.',
  bookedEmployee: 'Gebuchter Mitarbeiter',
  certificatesOfBookedEmployee: 'Qualifikationen des gebuchten Mitarbeiters',
  desiredCertificates: 'Gesuchte Qualifikationen',
  internalDescription: 'Interne Beschreibung',
  archivedJobsReport: 'Archivierte Dienste',
  archivedJobsReportDescription:
    'Alle Archivierten Dienste mit Schichten und gebuchten Mitarbeitenden',
  transferReport: 'Transfers',
  transferReportDescription:
    'Übersicht aller Transfers, für den gewählten Zeitraum',
  availabilityUpdatesReport: 'Verfügbarkeiten Anpassungen',
  availabilityUpdatesReportDescription:
    'Übersicht aller Änderungen der Verfügbarkeiten',
  internalId: 'Interne ID',
  updatedAt: 'Geändert am',
  updatedBy: 'Geändert von',
  availabilityStatusEnum: {
    AVAILABLE: ' Verfügbar',
    UNAVAILABLE: 'Nicht verfügbar',
    WORKING: 'In Arbeit',
  },
  disponentOverview: 'Disponenten Übersicht',
  disponentAssignmentReportDescription:
    'Übersicht über alle Disponenten und ihre Berechtigungen',
  restrictedToDepartments: 'Eingeschränkt auf Abteilungen',
  restrictedToCertificates: 'Qualifikationen',
  planningMatrixReport: 'Planungsmatrix',
  planningMatrixReportDescription:
    'Planungsmatrix zur optimalen Verteilung der buchbaren Mitarbeitenden. Hinweis: Es wird nur das "von" Datum für diesen Report berücksichtig',
  planningMatrixReportHeaderRowTitle: 'Anleitung: \n',
  planningMatrixReportHeaderRowDescription:
    'Für die Buchungs-Planung ein "b" in entsprechende Zelle eintragen.',
  hoursByDepartment: 'Stunden nach Abteilung',
  hoursByDepartmentDescription:
    'Übersicht der geleisteten Stunden pro Abteilung',
  customerConnectionsReport: 'Verbundene Kunden',
  customerConnectionsReportDescription:
    'Übersicht der Kunden welche mit Transfer oder SharedPool verbunden sind',
  currentlyActiveEmployments: 'Laufende Temporär-Einsätze',
  currentlyActiveEmploymentsDescription:
    'Eine Liste aller für den gewählten Zeitraum gebuchten Temporär-Einsätze mit Einsatzort und Pensum',
  connectedViaJobs: 'via Dienste',
  connectedViaEmployments: 'via Temporäre Einsätze',
  departmentDeselected: 'Abteilung abgewählt',
  departmentDeselectedByPooler: 'Diese Abteilung wurde vom Pooler abgewählt',
  caseNumber: 'Fallnummer',
  caseNumberShort: 'Fallnr.',
  costCenter: 'Kostenstelle',
  multiDayEdit: 'Serie bearbeiten',
  waiting: 'wartend',
  invited: 'eingeladen',
  intrested: 'Interessiert',
  notIntrested: 'Nicht Interessiert',
  partiallyIntrested: 'Teilweise Interessiert',
  reportedAvailable: 'Verfügbar gemeldet',
  hasAvailablePeople: 'Verfügbare Personen',
  restViolationsDetected: 'Ruhezeit nicht gewährleistet',
  pricePerHourIfNotSpecified:
    'Preis pro Stunde (falls kein fixer Tarif vereinbart)',
  confirmIgnoreRestViolations:
    '{{violations}}\n\nMöchten Sie trotzdem fortfahren?',
  waitingForResponse: 'Warten auf Antwort',
  thereAreXJobsWithOpenInvitations:
    'Es gibt {{count}} Dienste mit offenen Zusagen für diesen Tag.',
  thereIsAnOpenInvitationForThisDay:
    'Es gibt eine offene Zusage für diesen Tag.',
  shouldCancelOpenInvitations: 'Sollen diese abgesagt werden?',
  cancelOpenInvitations: 'Dienste absagen',
  keepOpenInvitations: 'Dienste offen lassen',
  cancelOpenInvitation: 'Dienst absagen',
  keepOpenInvitation: 'Dienst offen lassen',
  noOpenInvitations: 'Keine offenen Anfragen',
  createNewJob: 'Neuer Dienst',
  nextTransferAt: 'nächster am {{date}}',
  loadingJobs: 'Dienste werden geladen...',
  noJobsFound: 'Keine Dienste gefunden',
  editTimes: 'Zeiten bearbeiten',
  editShifts: 'Schichten bearbeiten',
  criteria: 'Kriterien',
  readOnlyOwnerAccessHint:
    'Dieser Dienst wurde von einem Vermittler erstellt und kann daher nicht bearbeitet werden.',
  careSector: 'Erfahrung / Pflegebereich',
  accept: 'akzeptieren',
  accepted: 'akzeptiert',
  partialAccept: 'teilweise akzeptieren',
  partialAccepted: 'teilweise akzeptiert',
  answered: 'Beantwortet',
  partialAcceptEdit: 'Zeiten bearbeiten',
  acceptAndClose: 'akzeptieren und abschliessen',
  reask: 'erneut Anfragen',
  setToUnavailable: 'auf nicht verfügbar setzen',
  setToAvailable: 'auf verfügbar setzen',
  includeUndecided: 'Unbekannte Verfügbarkeit berücksichtigen',
  previousJobsInThisDepartmentOfLast3Months:
    'Dienste der letzten 3 Monate bei dieser Abteilung / Organisation',
  previousEmploymentsInThisDepartmentOfLast3Months:
    'Einsätze der letzten 3 Monate bei dieser Abteilung / Organisation',
  upcoming: 'kommend',
  invite: 'einladen',
  book: 'buchen',
  inviteAndBook: '{{inviteCount}} Einladen und {{bookCount}} Buchen',
  inviteAndSuggest: '{{inviteCount}} Einladen und {{bookCount}} Einreichen',
  archived: 'archiviert',
  cancelJob: 'stornieren',
  conclude: 'abschliessen',
  availableEmployees: 'verfügbare Mitarbeitende',
  requestedEmployees: 'angefragte Mitarbeiter',
  acceptedAt: 'Akzeptiert am {{date}} ({{distance}})',
  declinedAt: 'Abgelehnt am {{date}} ({{distance}})',
  wasDeclinedAt: 'Wurde abgelehnt am {{date}} ({{distance}})',
  possibleCandidateAt: 'Kandidat eingereicht am {{date}} ({{distance}})',
  bookedAtWithDate: 'Gebucht am {{date}} ({{distance}})',
  cancelledAtWithDate: 'Storniert am {{date}} ({{distance}})',
  transcribedAtWithDate: 'Übertragen am {{date}} ({{distance}})',
  noResponseGiven: 'Dienst wurde bereits geschlossen',
  partialAcceptedAt: 'Teilweise akzeptiert am {{date}} ({{distance}})',
  jobAlreadyOccupied: 'Dieser Dienst wurde leider bereits besetzt',
  jobAlreadyCanceled: 'Dieser Dienst wurde leider bereits storniert',
  canceled: 'Storniert',
  automatically: 'automatisch',
  immediately: 'sofort',
  soon: 'bald',
  closeJobImmediately: 'Dienst sofort abschliessen',
  bookAndClose: 'buchen und abschliessen',
  transferred: 'transferiert',
  transferredAt: 'transferiert am {{date}} ({{distance}})',
  nextTransfer: 'nächster Transfer',
  tooManyJobs:
    'Es werden nur die nächsten {{limit}} Dienste dargestellt. Schränke bei Bedarf die Suche ein.',
  saveDefaultFilter: 'Filter speichern',
  showCanceledJobs: 'Stornierte Dienste anzeigen',
  onlyShowCanceledJobs: 'Nur Stornierte Dienste anzeigen',
  showOnlyActionRequiredBookableJobs:
    'Nur Dienste mit buchbarer Person anzeigen',
  showOnlyActionRequiredNoOpenInviteesJobs:
    'Nur Dienste ohne offene Einladungen anzeigen',
  onyShowBookedJobs: 'Nur Gebuchte Dienste anzeigen',
  icsDownload: 'Kalender',
  activateMultipleShifts: 'Geteilte Schichten aktivieren',
  requiredEmployees: 'Benötigte Mitarbeiter',
  submitAsPossibleCandidate: 'Kandidat einreichen',
  transferNow: 'Jetzt transferieren',
  transferAutomatically: 'Automatisch transferieren',
  preventDirectAccept: 'Direktbuchen verbieten',
  allowDirectAccept: 'Direktbuchen erlauben',
  directTransfer: 'Direkt Transferieren',
  declineJob: 'Dienst ablehnen',
  important: 'Wichtig',
  confirmPoolerAvailability:
    'Sie erfassen eine manuelle Dienstzusage. Bitte bestätigen Sie, dass Sie vorgängig eine mündliche Zusage des Mitarbeitenden für diesen Dienst erhalten haben.',
  will: 'wird',
  transferInvitee: 'umbuchen',
  poolerDoesNotHaveSelectedJobType:
    'Der ausgewählte Jobtyp ist im Profil des Mitarbeitenden nicht aktiviert',
  transferInviteeDepartmentNotAssignedTitle: 'Station nicht zugewiesen',
  transferInviteeDepartmentNotAssignedWarning:
    'Der ausgewählte Mitarbeitende ist dieser Station bzw. Abteilung nicht zugewiesen. Möchten Sie die Umbuchung trotzdem durchführen?',
  transferInviteeTransferAnyway: 'Trotzdem umbuchen',
  submitEmployees: 'Mitarbeiter einreichen',
  previouslyPossibleEmployeesSection: 'Erneut einreichbare Mitarbeitende',
  previouslyPossibleEmployeesHint:
    'Der Dienst wurde neu ausgeschrieben und die zuvor eingereichten Mitarbeiter können erneut eingereicht werden.',
  resubmitPreviouslyPossibleEmployee: 'Erneut einreichen',
  user: 'Mitarbeiter',
  booked_user: 'Gebuchte Mitarbeiter',
  canceled_user: 'Stornierte Mitarbeiter',
  shiftStart: 'Dienstbeginn',
  shiftEnd: 'Dienstende',
  confirmPoolerWithNotes:
    'Die Person welche Sie buchen wollen hat folgende Notizen: ',
  onlyAvailableEnd: ' verfügbar',
  userPartiallyAcceptedForTime:
    'Der Mitarbeitende hat für die angegebene Zeit teilweise Zugesagt',
  confirmManyInvites: 'Möchten Sie wirklich über 50 Einladungen versenden?',
  addToField: 'Bis hinzufügen',
  removeToField: 'Bis entfernen',
  restNotGuaranteed: 'Ruhezeit nicht gewährleistet',
  unknownAvailability: 'Verfügbarkeit unbekannt',
  unknown: 'Unbekannt',
  hasNote: 'Notiz vorhanden',
  note: 'Notiz',
  restTime: 'Ruhezeit',
  deselectAllEmployees: 'Alle Mitarbeitenden Abwählen',
  selectAllEmployees: 'Alle Mitarbeitenden Auswählen',
  inviteXOfYPeople: '{{count}} Mitarbeitende einladen',
  bookXPeopleDirectly: '{{count}} Mitarbeitende sofort buchen',
  addAnotherDate: 'Weiteres Datum hinzufügen',
  confirmJobAcceptAvailablePoolerPre: 'Möchtest du dich für den Dienst am',
  confirmJobAcceptAvailablePoolerPost: 'bewerben?',
  confirmJobAcceptUnavailablePoolerPre: 'Stelle sicher, dass du am',
  confirmJobAcceptUnavailablePoolerPost:
    'verfügbar bist. Möchtest du dich für diesen Dienst bewerben?',
  confirmAutoBookInviteeAcceptJob:
    'Die Zusage ist verbindlich und kann nicht mehr geändert werden.',
  repeatingJob: 'Wiederholender Dienst',
  createJobs: '{{count}} Dienste erstellen',
  editShiftTimes: 'Dienstzeit anpassen',
  transferNowPre: 'Möchten Sie diesen Dienst sofort an',
  transferNowAll: 'alle Vermittler',
  transferNowPost: 'transferieren?',
  transferToAll: 'Alle transferieren',
  automaticallyAt: 'automatisch am {{date}} ({{distance}})',
  automaticallyAfterBlocked: 'automatisch nach Sperrfrist in ({{distance}})',
  blockedUntil: 'Gesperrt bis: ',
  automaticallyImmediately: 'automatisch sofort',
  declineReason: 'Ablehnungsgrund',
  jobInPastWarning: {
    '0': 'Dieser Dienst liegt in der Vergangenheit. Bitte beachten:',
    '1': 'Mitarbeitende können nur sofort gebucht werden',
    '2': 'Es werden keine Benachrichtigung versendet',
    '3': 'Verfügbarkeiten werden nicht berücksichtigt',
  },
  confirmTransferReject: 'Möchten Sie den Dienst wirklich ablehnen?',
  workTime: 'Arbeitszeit',
  checkHours: 'Stunden prüfen',
  recordHours: 'Stunden erfassen',
  requiredUsersAmount: 'Anzahl benötigter Personen',
  deleteConfirmTitle: 'Dossier entfernen?',
  deleteConfirmContent:
    'Das Dossier wird gelöscht und kann nicht wiederhergestellt werden',
  internalInformation: 'Interne Informationen',
  internalInformationSubline:
    'Diese Informationen sind nur für {{customerName}} sichtbar und werden bei einem Transfer nicht mitgesendet',
  internalPoolers: 'Interne Pooler',
  bookedInvitees: 'Gebuchte Mitarbeiter',
  transfers: 'Transfers',
  demandReason: 'Bedarf',
  internalNote: 'Notiz',
  createdAt: 'Erstellt am',
  closedJobTooltip: 'Gebucht am {{date}} ({{distance}})',
  transfersTooltip: 'Transferiert / Total mögliche Transfers',
  declinedTransfersTooltip: 'abgelehnte Transfers',
  activeAutoTransfersTooltip: 'aktive automatische Transfers',
  requests: 'Anfragen',
  bookedServices: 'Gebuchte Dienste',
  archivedServices: 'Archivierte Dienste',
  hideAllRequests: 'Alle verpassten Dienste ausblenden',
  monthlyWorkingHoursTooltip:
    '{{percentage}}% | {{current}}/{{total}} Stunden diesen Monat gebucht',
  assignment: 'Einsatz',
  employment: 'Einsatz',
  createNewEmployment: 'Neuer Einsatz',
  availabilityNotes: 'Verfügbarkeitsnotizen',
  availabilityNoteFormat: '{{start}} bis {{end}}: {{note}}',
  possibleCandidates: 'Möglicher Kandidat',
  showHistory: 'Verlauf anzeigen',
  inviteAndCreate: 'Einladen und erstellen',
  inviteAndSave: 'Einladen und speichern',
  cancelEmployment: 'Einsatz stornieren',
  showCanceledEmployments: 'Stornierte Einsätze anzeigen',
  tooManyEmployments:
    'Es werden nur die nächsten {{limit}} Einsätze dargestellt. Schränke bei Bedarf die Suche ein.',
  foundOtherPersonnel: 'Einsatz wurde bereits besetzt',
  creationMistake: 'Einsatz falsch erfasst',
  notNeededAnymore: 'Einsatz wird nicht mehr benötigt',
  otherReason: 'Anderer Grund',
  employmentHasBeenOccupied: 'Dieser Einsatz wurde leider bereits besetzt',
  match: 'Match',
  addAvailabilityField: 'Verfügbarkeit hinzufügen',
  removeAvailabilityField: 'Verfügbarkeit entfernen',
  qualifications: 'Qualifikationen',
  noEmployeesSubmitted: 'Keine Mitarbeitenden eingereicht',
  declineEmployment: 'Einsatz ablehnen',
  deleteFileConfirmTitle: 'Dossier entfernen?',
  deleteFileConfirmContent:
    'Das Dossier wird gelöscht und kann nicht wiederhergestellt werden',
  initialStartDate: 'Ursprüngliches Startdatum',
  initialEndDate: 'Ursprüngliches Enddatum',
  initialWorkload: 'Ursprüngliches Pensum',
  transferConfirmationText:
    'Möchtest du die Stunden wirklich abschliessen? Die Stunden können danach nicht mehr bearbeitet werden.',
  submitConfirmationText:
    'Möchten Sie die Stunden wirklich freigeben? Die Stunden können danach nicht mehr bearbeitet werden.',
  invalidBreakTime: 'Arbeitspause ungültig',
  submitTimeTracking: 'Stunden einreichen',
  approveHours: 'Stunden bestätigen',
  bookDirectly: 'sofort buchen',
  suggestDirectly: 'sofort einreichen',
  suggest: 'einreichen',
  personalInfoHelpText: 'Geschlecht und Name',
  weNeedSomeData: 'Wir benötigen noch einige Daten von dir',
  confirmEmail: 'E-Mail-Adresse bestätigen',
  pleaseConfirmEmail:
    'Bitte bestätigen Sie die neue E-Mail Adresse mit dem Bestätigungslink, welchen wir Ihnen zugestellt haben',
  resendSmsCode: 'SMS-Code erneut anfordern',
  resendConfirmationEmail: 'Bestätigungs E-Mail erneut anfordern',
  smsConfirmationCode: 'SMS-Bestätigungscode',
  mobilePhoneExample: 'Handynummer (z.B. +41791234567)',
  mobilePhoneNumber: 'Handynummer',
  notShowingAllUsers:
    'Es werden nur {{count}} Mitarbeitende dargestellt. Nutze das Suchfeld um andere Mitarbeitende zu sehen.',
  cancelBookedInvitee: 'Gebuchten Mitarbeitenden stornieren',
  reason: 'Grund',
  declineInvitee: 'Mitarbeiter ablehnen',
  availabilityNote: 'Notiz zur Verfügbarkeit',
  noRest:
    'Der ausgewählte Benutzer kann für diesen Dienst die Ruhezeit nicht einhalten.',
  createEmployment: 'Einsatz erstellen',
  shiftsLongName: {
    EARLY: 'Frühschicht',
    DAY: 'Mittelschicht',
    LATE: 'Spätschicht',
    NIGHT: 'Nachtschicht',
  },
  calendarWeek: 'KW',
  selectedShiftsHint:
    'Dies sind Ihre als verfügbar angegebenen Schichten. Den Standard können Sie in den Einstellungen anpassen.',
  inviteXUsers: '{{inviteCount}} Einladen',
  bookXUsers: '{{bookCount}} Buchen',
  dateRangeChips: {
    ALL: 'Alle',
    TODAY: 'Heute',
    TOMORROW: 'Morgen',
    WEEK: 'Diese Woche',
    NEXT_WEEK: 'Nächste Woche',
    MONTH: 'Dieser Monat',
    NEXT_MONTH: 'Nächster Monat',
    CUSTOM: 'Zeitraum',
    N30: '+30 Tage',
    N90: '+90 Tage',
    L30N30: '-30, +30 Tage',
    L90: '-90 Tage',
  },
  bookedForShift: {
    EARLY: 'für Frühschicht gebucht',
    DAY: 'für Mittelschicht gebucht',
    LATE: 'für Spätschicht gebucht',
    NIGHT: 'für Nachtschicht gebucht',
  },
  editNote: 'Notiz bearbeiten',
  addNote: 'Notiz hinzufügen',
  myAvailabilities: 'Meine Verfügbarkeiten',
  myDepartments: 'Meine Abteilungen',
  otherEmployeesAvailable:
    '{{date}} {{shiftLabel}}: {{count}} Andere Mitarbeitende verfügbar',
  addUser: 'Benutzer hinzufügen',
  active: 'aktiv',
  registered: 'registriert',
  former: 'ehemalige',
  type: 'Typ',
  notes: 'Notizen',
  notesPlaceholder:
    'Spezielles z.B. Frei am Wochenende, oder Frei an spezifischem Datum',
  unavailabilityReason: 'Abwesenheits Grund',
  unavailabilityReasonEnum: {
    HOLIDAY: 'Ferien',
    SICK: 'Krankheit',
    TRAINING: 'Weiterbildung',
    OTHER: 'Andere',
  },
  editAvailability: 'Verfügbarkeit bearbeiten',
  otherOrganisation: 'Andere Organisation',
  availabilitySelectionWarning: 'Achtung: Informationen zur Verfügbarkeit',
  availabilitySelectionWarningText:
    'Es gibt zusätzliche Informationen zu dieser Verfügbarkeit. Bitte überprüfen Sie diese.',
  restWarning: 'Ruhezeit nicht gewährleistet',
  inviteAgain: 'Erneut einladen',
  restWarningLong:
    'Die Ruhezeit von 11 Stunden ist nicht gewährleistet. Bitte überprüfen Sie die Ruhezeit manuell.',
  unlock: 'Freischalten',
  nextShiftStart: 'Nächste Schicht beginnt am:',
  lastShiftEnd: 'Letzte Schicht endet am:',
  downloadDossier: 'Dossier herunterladen',
  removeFromPool: '{{ name }} wirklich aus dem Pool entfernen?',
  impersonate: 'Als Benutzer anmelden',
  impersonateUser: 'Als {{ name }} anmelden?',
  returnToUser: 'zurück zum Benutzer',
  loadingProfile: 'Profil wird geladen',
  editingRequestedUserHint:
    'Es sind noch nicht alle Informationen verfügbar weil der Benutzer die Zusammenarbeitsanfrage noch nicht angenommen hat.',
  contactSettings: 'Kontakteinstellungen',
  getNotificationSms: 'Benachrichtigungen per SMS erhalten',
  getNotificationEmail: 'Benachrichtigungen per E-Mail erhalten',
  getNotificationPush: 'Benachrichtigungen per Push erhalten',
  twoFactorAuthEnabled: 'Zwei-Faktor-Authentifizierung aktiviert',
  allowPushNotifications: 'Push-Benachrichtigungen für diese Seite erlauben',
  enableJobs: 'Springer Pool aktivieren',
  enableEmployments: 'Temporär Pool aktivieren',
  getOwnJobConfirmations: 'Buchungsbestätigungen für eigene Dienste erhalten',
  disableUnsavedChangesWarning:
    'Warnung bei ungespeicherten Änderungen deaktivieren',
  disabledEmails: 'Abgewählte E-Mails',
  creatorNotifications: {
    ACCEPTED_TIME_TRACKING: 'Zeiterfassung akzeptiert',
    ACTION_REQUIRED_ACCEPT_INVITEE:
      'Dienst Aktion erforderlich - Pooler akzeptieren',
    ACTION_REQUIRED: 'Dienst Aktion erforderlich',
    APPROVE_TIME_TRACKING_FOR_CREATOR: 'Zeiterfassung genehmigen',
    APPROVE_TIME_TRACKING_REMINDER_FOR_CREATOR:
      'Zeiterfassung genehmigen – Erinnerung',
    BOOKED_INTERNAL: 'Dienst gebucht (interner Pool)',
    BOOKED_EXTERNAL: 'Dienst gebucht (externer Pool)',
    POSSIBLE_CANDIDATE: 'Möglicher Kandidat (Dienst)',
    INVITEE_CANCELED: 'Gebuchter Pooler hat Dienst storniert',
    JOB_CANCELED: 'Dienst storniert',
    TRANSFER_DECLINED: 'Transfer abgelehnt (Dienst)',
    INVITEE_REPLACED: 'Pooler ersetzt',
    EMPLOYMENT_BOOKED_INTERNAL: 'Einsatz gebucht (interner Pool)',
    EMPLOYMENT_BOOKED_EXTERNAL: 'Einsatz gebucht (externer Pool)',
    EMPLOYMENT_INVITEE_CANCELED: 'Gebuchter Pooler hat Einsatz storniert',
    EMPLOYMENT_ACTION_REQUIRED_ACCEPT_INVITEE:
      'Einsatz Aktion erforderlich - Pooler akzeptieren',
    EMPLOYMENT_ACTION_REQUIRED: 'Einsatz Aktion erforderlich',
    EMPLOYMENT_CANCELED: 'Einsatz storniert',
    EMPLOYMENT_INFORMATION_CHANGED: 'Einsatzinformationen geändert',
    EMPLOYMENT_POSSIBLE_CANDIDATE: 'Möglicher Kandidat (Einsatz)',
    EMPLOYMENT_TRANSFER_DECLINED: 'Transfer abgelehnt (Einsatz)',
    JOB_REQUEST_ACCEPTED: 'Dienstanfrage akzeptiert',
    JOB_REQUEST_DECLINED: 'Dienstanfrage abgelehnt',
    JOB_RETRACTION_REQUEST_ACCEPTED:
      'Anfrage zum Zurückziehen des Dienstes akzeptiert',
    JOB_RETRACTION_REQUEST_DECLINED:
      'Anfrage zum Zurückziehen des Dienstes abgelehnt',
  },
  noNotificationSelected:
    'Wenn Sie keine der zwei Optionen oder Push aktivieren, werden Sie bei neuen Dienstanfragen nicht automatisch informiert.',
  noShiftSelected:
    'Wenn keine Schicht aktiviert ist erhalten sie keine Dienstanfragen.',
  qualificationsProfileEditText:
    'Folgende Angaben können nicht von Ihnen selbst bearbeitet werden. Falls diese nicht korrekt sind, kontaktieren Sie bitte Ihren Arbeitgeber.',
  jobSettings: 'Diensteinstellungen',
  weWillContactYouAboutActivation:
    'Vielen Dank für das einreichen deiner Dokumente. Wir werden uns innerhalb eines Arbeitstages bei dir melden.',
  submitDocuments: 'Dokumente einreichen',
  showOnlySelected: 'Nur gewählte Abteilungen anzeigen',
  disabledByPooler: 'vom Mitarbeitenden deaktiviert',
  blacklistedByDepartment: 'von der Abteilung blockiert',
  EARLY: 'Frühschicht',
  DAY: 'Mittelschicht',
  LATE: 'Spätschicht',
  NIGHT: 'Nachtschicht',
  yourEmailWasSetTo: 'Ihre E-Mailadresse wurde auf',
  wasChangedAt: 'geändert am',
  yourPhoneWasSetTo: 'Ihre Telefonnummer wurde auf',
  notConnected: 'Nicht verbunden',
  loginSystems: 'Logins',
  additionalInformation: 'Zusatzinformationen',
  itKnowledge: 'IT Kenntnisse',
  clothingSize: 'Kleidergrösse',
  height: 'Körpergrösse',
  fileUploadInfo: 'Dossier in diesen Bereich ziehen oder klicken',
  yourDocuments: 'Deine Unterlagen',
  uploadedDocuments: 'vorhandene Dokumente',
  pleaseUploadFollowingFilesForUnlock:
    'Bitte übermittle uns folgende Unterlagen (falls vorhanden), damit wir dein Konto möglichst bald freischalten können',
  curriculumVitae: 'Lebenslauf',
  graduations: 'Abschlüsse',
  addGraduations: 'Abschluss hinzufügen',
  jobReferences: 'Arbeitszeugnisse',
  carLicenceOptional: 'Fahrausweis (optional)',
  permitsBGC: 'Bewilligungen (B / C / G)',
  defaultShiftsHint:
    'Die hier ausgewählten Schichten werden Standardmässig berücksichtigt.',
  defaultJobTypesHint:
    'Die hier ausgewählten Dienstarten werden Standardmässig berücksichtigt.',
  noJobTypeSelected:
    'Wenn keine Dienstart aktiviert ist erhalten sie keine Dienstanfragen.',
  canCreateDispoUsers: 'Kann Disponenten erstellen',
  canCreatePooler: 'Kann Pooler erstellen',
  uploadDossier: 'Dossier hochladen',
  manage: 'verwalten',
  read: 'lesen',
  see: 'sehen',
  update: 'bearbeiten',
  delete: 'löschen',
  canPooler: 'kann Pooler',
  canPermission: 'Kann Berechtigungen',
  canManageTranscribeJobList: 'Kann Übertragungsliste',
  canTransfers: 'Kann Dienste transferieren & Vorschläge buchen',
  canSharedPool: 'Kann externe Pooler direkt buchen (SharedPool)',
  canTariffAdmin: 'Hat Admin zugriff auf Tarife',
  canEditAssignmentDefaults: 'Kann Standard Dienstbeschreibung bearbeiten',
  canCustomerAdmin: 'Kann Admineinstellungen bearbeiten',
  canDispos: 'kann Disponenten',
  canJobAccess: 'Zugriff auf Springer-Pool',
  canEmploymentAccess: 'Zugriff auf Temporär-Pool',
  canRequester: 'Kann Besteller',
  canRequestsAccess: 'Kann Dienstanfragen ansehen',
  canApproveJobRequests: 'Kann Dienstanfragen genehmigen',
  canApproveHours: 'Kann Stunden freigeben',
  joinDate: 'Eintrittsdatum',
  leaveDate: 'Austrittsdatum',
  ccEmailHint: 'Bitte geben Sie die E-Mailadressen Komma separiert ein.',
  permissions: 'Berechtigungen',
  adminPermissions: 'Admin Berechtigungen',
  car: 'Mobilität',
  dateOfBirth: 'Geburtsdatum',
  location: 'Wohnort',
  zip: 'PLZ',
  departmentAccess: 'Abteilungszugriff',
  checkOwnAvailability: 'Eigene Verfügbarkeit berücksichtigen',
  poolRequestTitle: 'Zusammenarbeitsanfrage',
  poolRequestText:
    'möchte Sie in ihrem Pool aufnehmen. Zugriff auf Ihr Profil und Verfügbarkeiten erlauben und Dienstanfragen zulassen?',
  dispoRequestTitle: 'Einladung als Disponent',
  dispoRequestText:
    'möchte Sie als Disponent hinzufügen. Möchten Sie das die Einladung annehmen?',
  organisationRequestTitle: 'Neuer Einsatzort',
  organisationRequestText:
    'Möchtest Du zukünftig Dienstanfragen für diesen Einsatzort erhalten?',
  moreLink: 'zur Webseite',
  openJobs: 'Offene Dienste',
  newestRequests: 'Neueste Anfragen',
  possibleJobs: 'Mögliche Dienste',
  noMatchingEmployments: 'Keine passenden Einsätze gefunden',
  noMatchingJobs: 'Keine passenden Dienste gefunden',
  matchingOffers: 'Passende Angebote',
  possibleEmployments: 'Mögliche Einsätze',
  nextJob: 'Nächster Dienst',
  actionRequiringJobs: 'Aktion erfordernde Dienste',
  nextEmployment: 'Nächster Einsatz',
  pendingTimetrackingJobs: 'Offene Zeiterfassung',
  noJobFound: 'Kein Dienst gefunden',
  noEmploymentFound: 'Kein Einsatz gefunden',
  showAllJobs: 'Alle Dienste anzeigen',
  showAllEmployments: 'Alle Einsätze anzeigen',
  userWasInvited: 'Benutzer wurde eingeladen.',
  userWasReasked: 'Benutzer wurde erneut angefragt.',
  jobReopenedInviteNotificationSent:
    'Es wurde eine erneute Anfrage nach Dienst-Wiedereröffnung an den Benutzer versendet.',
  jobReminderSent: 'Diensterinnerung versendet',
  inviteReminderSent: 'Anfragen erinnerung versendet',
  userHasAccepted: 'Benutzer hat angenommen.',
  userHasDeclined: 'Benutzer hat abgelehnt.',
  userHasPartiallyAccepted: 'Benutzer hat teilweise zugesagt.',
  userHasEditedPartialTimes:
    'Benutzer hat die teilweise zugesagten zeiten angepasst.',
  userWasAccepted: 'Benutzer wurde gebucht.',
  userWasSubmittedAsPossibleCandidate:
    'Benutzer wurde als möglicher Kandidat eingereicht',
  userWasTransferredFrom: 'Benutzer wurde von',
  userWasTransferredTo: 'Benutzer wurde zu',
  userWasDeclined: 'Benutzer wurde abgelehnt.',
  userBookedOnAnotherJob: 'Benutzer wurde bei einem anderen Dienst gebucht.',
  userAvailableBecauseJobCancelled:
    'Benutzer ist wieder verfügbar, da anderer Dienst storniert wurde.',
  userSetToAvailable:
    'Benutzer wurde von einem Disponent auf "Verfügbar" gesetzt.',
  userSetToUnavailable:
    'Benutzer wurde von einem Disponent auf "nicht Verfügbar" gesetzt.',
  userWasCancelled: 'Benutzer wurde storniert.',
  invitedByCategory: 'Benutzer wurde per {{category}} eingeladen.',
  acceptedByCategory: 'Benutzer wurde per {{category}} gebucht.',
  cancelledByCategory: 'Benutzer wurde per {{category}} storniert.',
  declinedByCategory: 'Benutzer wurde per {{category}} abgelehnt.',
  reAskedByCategory: 'Benutzer wurde per {{category}} erneut angefragt.',
  userSubmittedAsPossibleCandidate:
    'Benutzer wurde als möglicher Kandidat eingereicht',
  userSelfSignIn: 'Benutzer ohne Einladung stellt sich selbst zur Verfügung',
  userSelfSignInWithAvailability:
    'Benutzer mit Verfügbarkeit stellt sich selbst zur Verfügung',
  userSelfSignInWithoutAvailability:
    'Benutzer ohne Verfügbarkeit stellt sich selbst zur Verfügung',
  userSelfSignInHasDeclined: 'Benutzer ohne Einladung hat abgelehnt.',
  userWasReplaced: 'Benutzer wurde durch ein anderen Pooler ersetzt.',
  oClock: 'Uhr',
  by: 'von',
  history: 'Verlauf',
  toOldJob: 'Zum alten Dienst',
  toNewJob: 'Zum neuen Dienst',
  userReportedForSelfSignIn:
    'Benutzer hat sich für den Dienst als Verfügbar gemeldet',
  requestShift: 'Schicht anfragen',
  approve: 'Genehmigen',
  sendXRequests: '{{count}} Anfragen senden',
  retract: 'Zurückziehen',
  requestRetraction: 'Zurückziehen anfragen',
  jobRequestRequestRetraction: 'Zurückziehen angefragt',
  requestRetractionRequestedAt:
    'Zurückziehen angefragt von {{firstName}} {{lastName}} am {{date}}',
  approveRetractionOnRequest: 'Zurückziehen freigeben',
  rejectRetractionOnRequest: 'Zurückziehen ablehnen',
  requestOpenedAt: 'Anfrage gesendet am {{date}}',
  requestApprovedAt: 'Akzeptiert am {{date}}',
  requestApprovedAtBy: 'Akzeptiert am {{date}} von {{name}}',
  requestRejectedAt: 'Anfrage abgelehnt am {{date}}',
  requestRejectedAtBy: 'Anfrage abgelehnt am {{date}} von {{name}}',
  requestBookedAt: 'Gebucht am {{date}}',
  requestArchivedAt: 'Anfrage archiviert am {{date}}',
  requestCanceledAt: 'Storniert am {{date}}',
  requestRetractedAt: 'Anfrage zurückgezogen am {{date}}',
  noActiveDepartment: 'Bitte wählen Sie eine Abteilung aus',
  noOpenJobRequests: 'Keine offenen Dienstanfragen',
  pastJobs: 'Vergangene Dienste',
  pastThreeMonthsDescription: 'in den letzten 3 Monaten',
  in: 'bei',
  worked: 'gearbeitet',
  moreThanThreeMonthsDescription: 'Mehr als 3 Monate zurück',
  noPastJobs: 'Keine vergangenen Dienste',
  planningMatrix: 'Planungsmatrix',
  noOpenJobs: 'Keine offenen Dienste',
  clearAllFilters: 'Filter löschen',
  support: 'Support',
  supportTextUniversaljob:
    'Wenn du Fragen oder Probleme hast, zögere nicht deine/n Personalberater/in zu kontaktieren oder sende eine E-Mail an:',
  supportText: 'Bei Problemen kannst du dich gerne an den Support wenden:',
  supportTextNotLoggedIn:
    'Wenn du Fragen oder Probleme hast, zögere nicht deinen Arbeitgeber zu kontaktieren oder dich bei uns per E-Mail zu melden.',
  downloadGuideTextInformal: 'Du kannst unsere Anleitung hier herunterladen:',
  downloadGuideTextFormal: 'Du kannst unsere Anleitung hier herunterladen:',
  downloadGuideTextForPooler:
    'Die Anleitung für die Pool Mitarbeitenden kannst du hier herunterladen:',
  downloadGuideTextForRequester:
    'Die Anleitung für die Besteller kannst du hier herunterladen:',
  phoneContactOutsideOpeningHours:
    'Ausserhalb unserer Öffnungszeiten erreichst du uns telefonisch unter:',
  supportTextPooler:
    'Wenn du Fragen oder Probleme hast, zögere nicht deinen Arbeitgeber zu kontaktieren.',
  supportTextRequester:
    'Wenn du Fragen oder Probleme hast, zögere nicht deinen Arbeitgeber zu kontaktieren.',
  deleteProfileText:
    'Falls du dein Konto vollständig löschen möchtest, melde dich hier:',
  deleteProfileTextNotLoggedIn:
    'Falls du dein Konto vollständig löschen möchtest, musst du dich per E-Mail bei uns melden.',
  workDays: 'Montag bis Freitag',
  settings: 'Einstellungen',
  superAdmin: 'Super Admin',
  demoSettings: 'Demo Einstellungen',
  jobMatrix: 'Dienstmatrix',
  demoValidUntil: 'Demo gültig bis',
  qualification: 'Qualifikation',
  potentialInviteeCount: 'Verfügbar',
  noShiftsForWeekDaysHint: 'Keine Schichten für diesen Wochentag verfügbar',
  noShiftsForJobTypeHint: 'Keine Schichten für diese Dienstart verfügbar',
  noShiftsAvailableHint: 'Keine Schichten für diese Abteilung konfiguriert',
  cancelSomething: 'Stornieren',
  submitPossibleCandidate: 'Kandidat einreichen',
  sickness: 'Krankheit',
  accident: 'Unfall',
  PersonnelDeclined: 'Personal abgelehnt',
  customerDeclined: 'Kunde hat abgesagt',
  restTimeAfter7WorkingDays: 'Ruhezeit nach 7 Arbeitstage nicht eingehalten',
  otherJobOffer: 'Anderer Dienst angeboten',
  noCapacity: 'Keine Kapazität',
  requesterOverview: 'Besteller Übersicht',
  requesterAssignmentReportDescription:
    'Übersicht über alle Besteller und ihre Berechtigungen',
  autoBookInviteesCardTitle: 'Automatische Buchung',
  autoBookInvitees: 'Eingeladene Mitarbeiter automatisch buchen bei Zusagen',
  autoBookInviteesDepartmentDefault:
    'Eingeladene Mitarbeiter automatisch buchen bei Zusagen standardmässig auf Abteilungen aktivieren',
  autoBookSelfSignIns:
    'Mitarbeiter automatisch buchen bei Zusagen ohne Einladung buchen',
  autoBookSelfSignInsDepartmentDefault:
    'Mitarbeiter automatisch buchen bei Zusagen ohne Einladung buchen standardmässig auf Abteilungen aktivieren',
  jobMatrixHideCanceledJobs: 'Dienstmatrix stornierte Dienste ausblenden',
  jobMatrixForRequester: 'Dienstmatrix für Besteller anzeigen',
  jobMatrixCertificatePriority:
    'Qualifikationsprioritäten für die Dienstmatrix',
  jobMatrixCertificatePriorityDescription:
    'Die Prioritäten werden in der Dienstmatrix von oben nach unten berücksichtigt. Dienste mit mehreren Qualifikationen werden nur für die höchste Priorität angezeigt.',
  groupBy: 'Gruppieren nach: ',
  preventDirectAcceptWithinHoursPerShift:
    'Direkte Buchung innerhalb von x Stunden vor Dienstbeginn deaktivieren (1.5 = 1 Stunde 30 Minuten)',
  statusAfterCancelEnum: {
    AVAILABLE: 'Verfügbar',
    UNAVAILABLE: 'Nicht verfügbar',
    WORKING: 'In Arbeit',
    UNKNOWN: 'Unbekannt',
  },
  smsDisabledForDemo: 'SMS Versandt ist für Demo Umgebungen deaktiviert',
  userExistsInDemo:
    'Dieser Benutzer existiert in einer Demo, bitte wende dich an den inpool Support.',
  userAlreadyExists: 'Der Benutzer ist bereits registriert',
  demoSetupCompleted: 'Demo-Umgebung erfolgreich erstellt',
  demoExpired: 'Ihre Demo-Version ist abgelaufen',
  title: 'Titel',
  welcomeTextDemoRegistration:
    'Herzlich Willkommen bei der Demo von inpool. Du kannst in wenigen Schritten deine individuelle Demo-Umgebung konfigurieren und anschliessend inpool kostenlos testen.',
  startButton: 'Start',
  configureDemoTitle: 'Demo konfigurieren',
  isAgencyQuestion: 'Bist du ein Personaldienstleister?',
  organizationNameLabel: 'Wie heisst deine Organisation?',
  monthlyServicesLabel: 'Wie viele Dienste werdet ihr pro Monat buchen?',
  demoOrganisationType: {
    AGENCY: 'Personaldienstleister',
    HOSPITAL: 'Spital / Klinik',
    PSYCHIATRY: 'Psychiatrie',
    LONGTERM_CARE: 'Langzeitpflege',
    SPITEX: 'Spitex',
  },
  submitButton: 'Los gehts',
  generatingTitle: 'Demo wird eingerichtet',
  generatingText: 'Wir erstellen nun deine Demo-Umgebung, bitte warten...',
  redirectingToDashboard: 'Du wirst zum Dashboard weitergeleitet...',
  fillAllFields: 'Bitte fülle alle Felder aus',
  loadingSteps: {
    creatingOrganization: 'Organisation wird erstellt',
    generatingEmployees: 'Mitarbeiter werden generiert',
    generatingOpenJobs: 'Offene Dienste werden generiert',
    generatingArchivedJobs: 'Archivierte Dienste werden generiert',
  },
  welcomeTitle: 'Juhui, du hast es geschafft...',
  welcomeTextDemoUserSetup: 'Die Demo ist nun eingerichtet.',
  welcomeTextDemoUserSetup2:
    'Damit du dich zukünftig wieder anmelden kannst und deine Einstellungen nicht verloren gehen, erstellen wir zuerst gemeinsam einen Benutzer für dich.',
  welcomeTextDemoUserSetup3: 'Klicke auf "Weiter" sobald du bereit bist.',
  userFormTitle: 'Benutzer anlegen',
  businessEmailLabel: 'Geschäftliche E-Mail',
  submitUserButton: 'Benutzer anlegen',
  confirmEmailTitle: 'E-Mail bestätigen',
  confirmEmailText: 'Vielen Dank für deine Angaben.',
  confirmEmailText2:
    'Wir haben dir eine E-Mail an deine E-Mailadresse <b>{{email}}</b> gesendet.',
  confirmEmailText3:
    'Bitte klicke in der E-Mail auf den Link um dein Passwort zu setzen.',
  confirmEmailText4:
    'Dieses Fenster wird automatisch geschlossen sobald die Einrichtung deines Benutzers abgeschlossen ist.',
  checkYourData: 'Bitte prüfe deine Angaben',
  demoEmailExistsAlreadyError:
    'Ein Benutzer mit der E-Mail-Adresse "{{email}}" existiert bereits. Um sich mit dem Benutzer anzumelden, wählen sie "Abbrechen" um zum Login zu gelangen. Falls Sie Ihr Passwort nicht mehr wissen, können Sie dort Ihre E-Mail-Adresse angeben und dann die funktion "Passwort vergessen" benutzen.',
  invalidEmail: 'Bitte gebe eine gültige E-Mail-Adresse ein',
  demoDurationHint:
    'Diese Demo ist gültig bis {{validUntil}} ({{remainingDays}} Tage verbleibend)',
  demoExpiredTodayHint: 'Diese Demo ist heute abgelaufen ({{expiredAt}})',
  demoExpiredHint:
    'Diese Demo ist abgelaufen am {{expiredAt}} (vor {{daysAgo}} Tagen)',
  extendDurationTitle: 'Demo-Dauer verlängern',
  extendDurationDescription: 'Wählen Sie ein neues Ablaufdatum für diese Demo.',
  newValidUntilDate: 'Neues Ablaufdatum',
  disableDemo: 'Demo deaktivieren',
  deleteDemo: 'Demo löschen',
  switchToLive: 'Live schalten',
  disableDemoTitle: 'Demo deaktivieren?',
  disableDemoMessage: 'Das Ablaufdatum wird dadurch auf heute gesetzt.',
  deleteDemoTitle: 'Demo löschen?',
  deleteDemoMessage:
    'Möchtest du die Demo {{name}} wirklich löschen? Dadurch werden alle Demo-Daten unwiderruflich gelöscht.',
  customerName: 'Kundenname',
  switchToLiveTitle: 'Zu Live-Kunde wechseln?',
  switchToLiveMessage:
    'Dadurch wird dieser Demo-Kunde in einen Live-Kunden umgewandelt.',
  generatedDataWillBeDeleted: 'Alle generierten Daten werden gelöscht.',
  deleteOptions: 'Löschoptionen',
  deleteManuallyCreatedJobs: 'Manuell erstellte Dienste löschen',
  deleteManuallyCreatedPoolers: 'Manuell erstellte Pooler löschen',
  deleteManuallyCreatedDispos: 'Manuell erstellte Dispos löschen',
  deleteManuallyCreatedEmployments: 'Manuell erstellte Einsätze löschen',
  confirmSwitchToLiveTitle: 'Wechsel zu Live-Kunde bestätigen',
  confirmSwitchToLiveMessage:
    'Möchtest du {{name}} wirklich zu einem Live-Kunden machen? Diese Aktion kann nicht rückgängig gemacht werden.',
  durationExtended: 'Demo-Dauer erfolgreich verlängert',
  demoDisabled: 'Demo erfolgreich deaktiviert',
  demoDeleted: 'Demo erfolgreich gelöscht',
  switchedToLive: 'Erfolgreich zu Live-Kunde gewechselt',
  errorExtendingDuration: 'Fehler beim Verlängern der Demo-Dauer',
  errorDisablingDemo: 'Fehler beim Deaktivieren der Demo',
  errorDeletingDemo: 'Fehler beim Löschen der Demo',
  errorSwitchingToLive: 'Fehler beim Wechsel zu Live-Kunde',
  poolerTypeBookingWarningDefaultMessage:
    'Sind sie sicher, dass sie den Mitarbeitenden der Poolerart {{poolerType}} für den Dienst buchen möchten?',
  bookingWarningEnabled: 'Warnung bei Buchung aktivieren',
  bookingWarningMessage: 'Warnung bei Buchung',
  bookingWarningTitle: 'Buchungswarnung für {{firstName}} {{lastName}}',
  enableTimeTrackingSigninProcess: 'Unterschrift für Zeiterfassung aktivieren',
  autoAddTimeTrackingHours:
    'Standardzeiten automatisch nach X Stunden einreichen wenn nicht von Pooler eingegeben',
  requestSignature: 'Unterschrift einholen',
  requestSignatureIntro:
    'Bitte begebe dich zur dienstverantwortlichen Person und übergebe ihr dein Gerät für die digitale Unterzeichnung deiner Stunden.',
  requestSignatureIntroDetails:
    'Falls du keine Möglichkeit hast dein Gerät physisch zu übergeben, werden deine Stunden automatisch nach Ablauf der Frist per E-Mail übermittelt.',
  handOverDevice: 'Bitte übergebe jetzt dein Gerät',
  checkHoursDescription:
    'Bitte prüfe und korrigiere bei Bedarf die Arbeitszeit von {{name}}.',
  signHours: 'Stunden visieren',
  signHoursDescription:
    'Bitte erfasse deinen Namen und bestätige die Stunden mit deiner Unterschrift.',
  signHere: 'Hier unterschreiben',
  clear: 'Löschen',
  signatureRequired: 'Unterschrift ist erforderlich',
  timeTrackingConfirmation: 'Vielen Dank',
  timeTrackingConfirmationDescription:
    'Wir haben die Stundenfreigabe erhalten. Du kannst das Gerät nun <b>zurückgeben</b>.',
  sign: 'Visieren',
  timeRemaining: 'Verbleibend',
  timerExpired: 'Frist abgelaufen',
  timerExpiredDescription:
    'Die Frist ist abgelaufen. Deine Stunden wurden per E-Mail zur Freigabe übermittelt.',
  bookingWebHookTitle: 'Buchungs-Webhook',
  bookingWebHookDescription:
    'Die Buchungs-Webhook wird aufgerufen wenn Mitarbeiter im Springer-Pool gebucht oder storniert werden.',
  bookingWebHookUrl: 'Webhook URL',
  bookingWebHookApiKey: 'API-Schlüssel',
  bookingWebHookApiKeyCurrent: 'Aktuell:',
  bookingWebHookApiKeyLeaveEmpty: 'leer lassen um unverändert zu belassen',
  carePeoplePoolerBookingFailed:
    'Mitarbeitender konnte bei nicht CarePeople gebucht werden',
  vokusPoolerBookingFailed:
    'Mitarbeitender konnte bei Vokus nicht gebucht werden',
  enablePerigonApi: 'Perigon API aktivieren',
  perigonTaskId: 'Perigon Task ID',
  perigonId: 'Inpool ID (Perigon)',
  addPerigonShiftMapping: 'Perigon Schicht-Zuordnung hinzufügen',
  perigonMapping: 'Perigon Zuordnungen',
  perigonMappingIncompleteAt: 'Perigon-Zuordnung unvollständig seit',
  perigonMappingIncomplete: 'Perigon-Zuordnung unvollständig',
  showUnmappedJobs: 'Nur Dienste mit fehlender Perigon-Zuordnung',
  timeTrackingEnabledByOwnerTooltip: 'Von der Einrichtung aktiviert',
  timeTrackingDefaultPause:
    'Standardpause in Stunden (wenn nicht auf Schicht hinterlegt)',
  timeTrackingDefaultPauseByDepartment: 'Standard Pause pro Schicht',
  default: 'Standard',
  sharedPoolAllowUndecided:
    'Unbekannte Verfügbarkeit bei Shared Pool als Option anzeigen',
  disableTimetrackingForNewOrganisationsByDefault:
    'Zeiterfassung für neue Organisationen standardmässig deaktivieren',
  instructions: 'Anleitung',
  noEmploymentsFound: 'Keine Einsätze gefunden',
  showOnlyUnapprovedHours: 'Nur ungeprüfte Stunden anzeigen',
  allowExternalPoolers: 'Externes Personal berücksichtigen',
  disableDispoFilterSave: 'Dispo Filter speichern deaktivieren',
  requiredPause: 'Benötigte Pause in Stunden zwischen zwei Diensten',
  wardManagement: 'Mitarbeiterpool',
  conditionalTransfers: 'Bedingte Transfers',
  requestersCanAccessReports: 'Besteller können Berichte ansehen',
  organisationNameLabel: 'Wie heisst deine Organisation?',
  organisationTypeQuestion: 'Art des Unternehmens',
  discard: 'Verwerfen',
  transfersConfirmed: 'Transfers bestätigt',
  transferConfirmationPerson: 'Bestätigungsperson',
  enableDescription: 'Beschreibung aktivieren',
  statusAfterCancel: {
    AVAILABLE: 'Verfügbar',
    UNAVAILABLE: 'Nicht verfügbar',
    WORKING: 'In Arbeit',
    UNKNOWN: 'Unbekannt',
  },
  requestersCanAccessJobOverviewReport:
    'Besteller können Dienstübersicht Bericht ansehen',
  perigonBearerToken: 'Perigon API Schlüssel',
  perigonClientId: 'Perigon Client ID',
  addPerigonTaskMapping: 'Perigon Task Mapping hinzufügen',
  loadingEmployments: 'Einsätze werden geladen',
  perigonMappingIncompleteDescription:
    'Die Perigon-Zuordnung ist unvollständig. Bitte überprüfen Sie die Perigon-Zuordnung und korrigieren Sie sie.',
  archiveAtType: 'Archivierungszeitpunkt',
  archiveAtTypeEnum: {
    START_OF_JOB: 'Anfang des Dienstes',
    END_OF_JOB: 'Ende des Dienstes',
  },
  archiveAtOffset: 'Archivierungszeitpunkt Offset in Minuten',
  confirmSaveCustomerFlags:
    'Möchten Sie die Admin-Einstellungen wirklich speichern, dies kann Einfluss auf bereits erfasste Dienste haben?',
  archiveAtOffsetDescriptionStartOfJob:
    'Beispiel: Dienst welcher um 7:00 beginnt wird um {{timeStamp}} archiviert.',
  archiveAtOffsetDescriptionEndOfJob:
    'Beispiel: Dienst welcher um 16:00 endet wird um {{timeStamp}} archiviert.',
  timeTrackingSettings: 'Zeiterfassung Einstellungen',
  reject: 'Ablehnen',
  elevenHourWarning:
    'Die Ruhezeit von 11 Stunden ist nicht gewährleistet. Bitte überprüfen Sie die Ruhezeit.',
  sevenDayWarning:
    'Die Ruhezeit von 83 Stunden nach 7 Tagen ist nicht gewährleistet. Bitte überprüfen Sie die Ruhezeit.',
  potentialSevenDayWarningWithInfraction:
    'Die Ruhezeit von 83 Stunden nach 7 Tagen kann nicht gewährleistet werden, wenn falls dieser Dienst gebucht wird. Bitte überprüfen Sie die Ruhezeit.',
  potentialSevenDayWarning:
    'Beim buchen dieser Schicht wird eine 7 Tage in Folge Schicht gebucht.',
  reportEnabledInOverview: 'Bericht in der Übersicht anzeigen',
  adminReportsAllDisabledWarning:
    'Alle Berichte sind ausgeblendet. Nutzer sehen in der Berichte-Übersicht keine Downloads mehr.',
  reportsEnum: {
    JOBS_FOR_INVOICE: 'Dienste für Rechnung',
    CURRENTLY_ACTIVE_EMPLOYMENTS: 'Laufende Temporär-Einsätze',
    EXTERNAL_CANCELLATIONS: 'Absagezeitpunkt externe Mitarbeitende',
    ACTIVITY: 'Inaktivität',
    TIME_TRACKING: 'Stundenrapport',
    SHIFTS_PLANNING: 'Dienstplanung',
    JOB_OVERVIEW: 'Dienstübersicht',
    DISPONENT_OVERVIEW: 'Disponenten Übersicht',
    REQUESTER_OVERVIEW: 'Besteller Übersicht',
    POOLER_OVERVIEW: 'Pooler Übersicht',
    AVAILABLE_USER_JOB_PLANNING: 'Mitarbeiter Planung',
    POOLER_REACTION_TIME: 'Mitarbeiter Reaktionszeit',
    SMS_USAGE: 'SMS Nutzung',
    USER_AVAILABILITY: 'Benutzer Verfügbarkeit',
    ARCHIVED_JOBS: 'Archivierte Dienste und gebuchte Mitarbeiter',
    TRANSFER: 'Transfer Report',
    AVAILABILITY_UPDATES: 'Verfügbarkeiten Anpassungen',
    PLANNING_MATRIX: 'Planungsmatrix',
    HOURS_BY_DEPARTMENT: 'Stunden nach Abteilung',
    CUSTOMER_CONNECTIONS: 'Verbundene Kunden',
  },
  saveNote: 'Notiz speichern',
  searchType: 'Suche nach',
  all_alternative: 'Alles',
  times: 'Stunden',
  enterHours: 'Stunden erfassen',
  enterHoursDescription: 'Bitte erfasse deine Arbeitszeiten für diesen Tag.',
  inviteeInternalId: 'Mitarbeitender interne ID',
};
